<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">
          {{ $t('building.name') }}<span class="text-danger">*</span>
        </label>
        <input
          ref="building_name"
          v-model="model.building_name"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('building_name') }"
          :placeholder="$t('building.enterBuildingName')"
        />
        <div class="invalid-feedback" v-if="errors.has('building_name')">
          {{ errors.first('building_name') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"> {{ $t('building.address') }} </label>
        <textarea
          v-model="model.address"
          class="form-control"
          :class="{
            'is-invalid': errors.has('address')
          }"
          rows="3"
          :placeholder="$t('building.enterBuildingAddress')"
        ></textarea>
        <div class="invalid-feedback" v-if="errors.has('address')">
          {{ errors.first('address') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('building.description') }}</label>
        <textarea
          v-model="model.bd_description"
          class="form-control"
          :class="{
            'is-invalid': errors.has('bd_description')
          }"
          rows="3"
          :placeholder="$t('building.enterBuildingdescription')"
        ></textarea>
        <div class="invalid-feedback" v-if="errors.has('bd_description')">
          {{ errors.first('bd_description') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'building-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        building_name: '',
        address: '',
        bd_description: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  mounted() {
    this.$refs.building_name.focus()
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'building' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('building/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.building_name.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('building/update', this.model)

        this.$toasted.success(response.message)
        this.$router.push({ name: 'building' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.building_name.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.building_name = ''
      this.model.address = ''
      this.model.bd_description = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
